
const APP_MENU_LANG = 'app-menu-lang';
import { Establishment } from 'app/models/establishment';

// Custom class to store the language in the localStorage
export class LanguagesUtils
{
    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Save the lang in the local storage
     * @param user
     */
    static saveLangInLocal(lang: string) {
        localStorage.removeItem(APP_MENU_LANG);
        localStorage.setItem(APP_MENU_LANG, lang);
    }
    
    /**
     * Get the lang from the local storage
     * @returns User
     */
    static getLocalLang(): string {
        const lang = localStorage.getItem(APP_MENU_LANG);
        // Japanese was stored as 'jp' (the country code) before the menu used its language code
        // 'ja': a value left by that time reads as 'ja', so it neither selects a missing language
        // nor becomes an unknown locale
        return lang === 'jp' ? 'ja' : lang;
    }

    /**
     * Get the lang from the establishment
     * @returns lang
     */
    static getMenuRemoteLang(establishment: Establishment): string {
        // Return empty string if establishment or its languages are not available
        if (!establishment || !establishment.establishmentLanguages || establishment.establishmentLanguages.length === 0) {
            return '';
        }

        const localLang = this.getLocalLang();
        if (localLang) {
            const establishmentLanguage = establishment.establishmentLanguages.find(el => el.languageRefCode.toUpperCase() === localLang.toUpperCase());
            if (establishmentLanguage) {
                return establishmentLanguage.languageRefCode;
            }
        }
        
        // Return the default language if available
        const defaultLanguage = establishment.establishmentLanguages.find(el => el.defaultLanguage);
        return defaultLanguage ? defaultLanguage.languageRefCode.toUpperCase() : '';
    }
    
}
